import fp1 from "./img-13.jpg";
import fp2 from "./img-14.jpg";
import fp3 from "./img-26.jpg";
import fp4 from "./img-27.jpg";
import fp5 from "./img-06.png";

const FLOOR_PLAN_KEYS = new Set([
  "./img-13.jpg",
  "./img-14.jpg",
  "./img-26.jpg",
  "./img-27.jpg",
  "./img-06.png",
]);

const photoModules = import.meta.glob('./img-*.{jpg,jpeg,png}', { eager: true, import: 'default' }) as Record<string, string>;

export const brezanyDumImages: string[] = Object.entries(photoModules)
  .filter(([key]) => !FLOOR_PLAN_KEYS.has(key))
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const brezanyDumFloorPlans: { image: string; label: string }[] = [
  { image: fp1, label: "Půdorys 1. NP" },
  { image: fp2, label: "Půdorys 1. NP – 3D" },
  { image: fp3, label: "Půdorys 2. NP" },
  { image: fp4, label: "Půdorys 2. NP – 3D" },
  { image: fp5, label: "Kopie katastrální mapy" },
];
